import React, { useCallback, useMemo } from 'react';
import { useHistory, useLocation, Route, Switch, Redirect } from 'react-router-dom';

import navbarReduce from '../../shared/data/navbar/navbarReduce';
import Page from 'Components/Page';
import TabOrderDetail from './components/TabOrderDetail';
import withAuthentication from 'Components/withAuthentication';
import ReactGA from 'Shared/analytics';

const OrderDetail = ({ profileData }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabRouter = (
    <>
      <Switch>
        <Route path="/customer/order/" exact render={() => <Redirect to="/customer/order/detail/" />} />
        <Route path="/customer/order/detail/:id" component={TabOrderDetail} />
      </Switch>
    </>
  );

  const activeTabId = useMemo(() => {
    return pathname.split('/')[3];
  }, [pathname]);

  const handleTabClick = useCallback(
    (tabClicked) => {
      if (tabClicked !== activeTabId) {
        history.replace(`/customer/order/${tabClicked}/`);
        ReactGA.pageview(`/customer/order/${tabClicked}/`, 'Order detail' + tabClicked);
      }
    },
    [history, activeTabId]
  );

  return (
    <Page
      props={{
        titleProps: {
          text: 'Orders',
        },
        navigation: {
          variant: 'tabs',
          tabsProps: {
            tabs: [
              {
                id: 'order',
                label: '',
              },
            ],
            onTabClick: handleTabClick,
            activeTabId,
          },
        },
        navbarProps: {
          points: navbarReduce(profileData),
          activePointId: 'order',
        },
        content: tabRouter,
      }}
    />
  );
};

export default withAuthentication(OrderDetail);
